<template>
  <div class="pdf-viewer">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12" style="text-align: center; margin-bottom: 25px">
                  <h1>{{this.title}}</h1>
                </div>
              </div>
              <div class="row">
                <div class="col-12 controls d-flex justify-content-center">
                  <button class="btn btn-primary" v-on:click="previousPage()">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-primary" v-on:click="nextPage()">
                    <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  </button>
                  <div class="page-control">
                    <label for>Página</label>
                    <input type="text" v-model="page_current" class="form-control" />
                    <span class="num-pages">/ {{numPages}}</span>
                  </div>
                </div>
                <div class="col-12 d-flex justify-content-center pdf-content">
                  <pdf :src="src_path" :page="i" class="pdf-frame"></pdf>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import { bus } from "@/main";

export default {
  name: "pdf-viewer",
  components: {
    pdf
  },
  props: {
    src_path: String,
    title: String
  },
  data() {
    return {
      items: [
        {
          text: "Área do cliente",
          route: "client.dashboard"
        },
        {
          text: "",
          active: true
        },
      ],
      src: "",
      srcPdf: "",
      numPages: 0,
      i: 1,
      page_current: 1
    };
  },
  mounted() {
    this.items[1].text = this.title;
    this.src = this.src_path;
    let promise = pdf.createLoadingTask(this.src);
    bus.$emit('changeLoading', true);
    promise.then(res => {
      this.numPages = res.numPages;
      bus.$emit('changeLoading', false);
    });
  },
  watch: {
    page_current: {
      handler: function(value) {
        if (value > 0 && value < this.numPages) {
          this.goToPage();
        } else {
          this.page_current = this.i;
        }
      }
    }
  },
  methods: {
    nextPage: function() {
      if (this.i + 1 == this.numPages) {
        this.i = this.numPages;
      } else {
        this.i++;
      }
      this.page_current = this.i;
    },
    previousPage: function() {
      if (this.i - 1 == 0) {
        this.i = 1;
      } else {
        this.i--;
      }
      this.page_current = this.i;
    },
    goToPage: function() {
      this.i = parseInt(this.page_current);
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.pdf-viewer {
  .controls {
    background-color: #5f6064;
    padding: 6px 8px;
    button {
      margin: 0 6px 0 6px;
    }
    .page-control {
      margin-left: 10vw;
      display: flex;
      align-items: center;
      color: rgb(194, 194, 194);
      font-size: 18px;
      .num-pages {
        margin-left: 8px;
      }
      label {
        margin-right: 8px;
        margin-bottom: 0px !important;
      }
      input {
        min-width: 40px;
        max-width: 60px;
      }
    }
  }
  .pdf-content {
    background-color: #848488;
    padding: 18px;
  }
  .pdf-frame {
    width: 60%;
  }
}
</style>